/**
 * PLATFORM MARKASININ TEK KAYNAĞI — env halkası (Faz 4 · Story 23.2 · karar P8).
 *
 * `BrandTokens` şekli `tokens.ts`tedir; BU dosya o şeklin **env'den nasıl
 * doldurulacağını** tek yerde yazar. Üç uygulama (api · web · mobil) aynı
 * fonksiyonu çağırır, yani "değer verilmemişse ne olur" sorusunun tek cevabı
 * vardır. Eskiden üç ayrı `?? '...'` zinciri vardı ve ÖLÇÜLDÜ: e-posta
 * şablonu `resolveBrand({ name, domain })` kuruyor, `primary`yi HİÇ
 * geçirmiyordu — `BRAND_PRIMARY` verilse bile e-postadaki düğme eski tonda
 * çiziliyordu (Blok 31 probu).
 *
 * A7 KAPANDI (marka geçişi 2026-08-28): görünen ad `WarmBreak`, alan adları
 * `warmbreak.com` / `warmbreak.com`, logo yolları `brand/warmbreak-*.svg`.
 * A7'nin vaadi tuttu — geçiş `defaultBrand` + logo dosyası + native görünen ad
 * kadar oldu; hiçbir ekranda ad aranmadı.
 *
 * P9: DAHİLİ kod adı (`@icebreaker/*`, bundle kimliği, şema adları) buranın
 * konusu DEĞİLDİR ve değişmez.
 */
import { resolveBrand } from './tokens';
/**
 * Geliştirme makinesinin alan adı. Marka domaini DEĞİLDİR — üretimde env verilir.
 *
 * Üç uygulamada da aynı sabit yazılıydı (`localhost:3000`); ayrıştığı gün
 * mobil kart bağlantısı web'in açmadığı bir kökü üretirdi.
 */
export const LOCAL_APP_DOMAIN = 'localhost:3000';
/** Env verilmediğinde kullanılan taban — api/web/mobil için AYNI. */
export const developmentBrand = resolveBrand({ domain: LOCAL_APP_DOMAIN });
/** Env'den doldurulabilen marka alanları. */
export const BRAND_ENV_FIELDS = [
    'name',
    'shortName',
    'domain',
    'publicDomain',
    'supportEmail',
    'logoLightUrl',
    'logoDarkUrl',
    'primary',
    'accent',
];
/**
 * ALAN → ENV ANAHTARI EŞLEMESİ (api tarafı · web tarafı).
 *
 * İKİ SÜTUN, TEK SATIR — kasten. `BRAND_PRIMARY` (api) ile
 * `NEXT_PUBLIC_BRAND_PRIMARY` (web) **aynı değeri** almak zorundadır: ayrışırsa
 * markasız etkinliğin 6px şeridi (sunucu zincirinden gelir) platformun geri
 * kalanından (web tokenlarından gelir) farklı tonda çizilir — Blok 29 ORTA-3
 * uyarısı tam olarak budur. Çift burada beyanlıdır ve
 * `brand-env-parity.guard.spec.ts` her env dosyasında ikisinin birlikte ve
 * AYNI değerle verildiğini makineyle doğrular.
 *
 * `primaryContrast` / `accentContrast` BİLİNÇLİ olarak env'de yoktur: onlar
 * kontrast kararıdır (erişilebilirlik kırmızı çizgisi), pazarlama kararı değil.
 */
export const BRAND_ENV_KEYS = {
    name: { api: 'APP_NAME', web: 'NEXT_PUBLIC_APP_NAME' },
    shortName: { api: 'APP_SHORT_NAME', web: 'NEXT_PUBLIC_APP_SHORT_NAME' },
    domain: { api: 'APP_PUBLIC_DOMAIN', web: 'NEXT_PUBLIC_APP_DOMAIN' },
    /*
     * VİTRİN ALAN ADI (marka sözleşmesi §1 · §7 footer satırı). Uygulama adresi
     * `warmbreak.com`, public sayfaların altında görünen adres `warmbreak.com`.
     * İkisi AYRI anahtardır çünkü ayrı DNS kayıtlarıdır; tek anahtara bağlanırsa
     * alt bilgi uygulama adresini yazar ve pazarlama adresi hiç görünmez.
     */
    publicDomain: { api: 'APP_MARKETING_DOMAIN', web: 'NEXT_PUBLIC_APP_MARKETING_DOMAIN' },
    supportEmail: { api: 'BRAND_SUPPORT_EMAIL', web: 'NEXT_PUBLIC_BRAND_SUPPORT_EMAIL' },
    logoLightUrl: { api: 'BRAND_LOGO_LIGHT_URL', web: 'NEXT_PUBLIC_BRAND_LOGO_LIGHT_URL' },
    logoDarkUrl: { api: 'BRAND_LOGO_DARK_URL', web: 'NEXT_PUBLIC_BRAND_LOGO_DARK_URL' },
    primary: { api: 'BRAND_PRIMARY', web: 'NEXT_PUBLIC_BRAND_PRIMARY' },
    accent: { api: 'BRAND_ACCENT', web: 'NEXT_PUBLIC_BRAND_ACCENT' },
};
/**
 * Okunmuş env değerlerinden marka tokenlarını kur.
 *
 * DEĞERLERİ ÇAĞIRAN OKUR, BU FONKSİYON OKUMAZ — Next.js `NEXT_PUBLIC_*`
 * değişkenlerini yalnızca **düz yazımda** (`process.env.NEXT_PUBLIC_X`) derleme
 * anında gömer; `process.env[key]` biçimindeki dinamik erişim istemci
 * paketinde `undefined` olur. Bu yüzden anahtar adları burada beyanlıdır ama
 * okuma her uygulamanın kendi env modülünde düz yazımla yapılır; guard
 * ikisinin ayrışmadığını denetler.
 *
 * Boş dize = verilmemiş sayılır (docker-compose boş değişkeni boş dize olarak
 * geçirir; `?? ` operatörü onu "verilmiş" sayıp markayı boşaltırdı).
 */
export function brandFromEnv(values, base = developmentBrand) {
    const overrides = {};
    for (const field of BRAND_ENV_FIELDS) {
        const value = values[field]?.trim();
        if (value)
            overrides[field] = value;
    }
    return { ...base, ...overrides };
}
//# sourceMappingURL=brand-env.js.map